var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWangjia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.4905H15.75",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.07544V11.4905",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.07544L8.25 10.8113",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0835 10.8112L12.2502 6.99048",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.4905V6.99048",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69434 3V10.5566",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19849 10.4524L7.80615 11.5342H9.61514L9.19316 10.4524H8.19849Z",
    fill: "#2F88FF",
    stroke: "#2F88FF",
    strokeWidth: 0.0874141
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.9999V11.0478L8.70732 3.08487L15.75 11.0478V11.9999",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWangjia);
export default __webpack_public_path__ + "static/media/wangjia.875fae0c9b1c8f3dd139b241136ddfa6.svg";
export { ForwardRef as ReactComponent };